import { create } from 'zustand';

// Open state of the first-run "connect your data" guide (ConnectOnboarding).
// Its own module so the Help menu can open it without importing the
// connector catalog into the sidebar.

interface ConnectOnboardingState {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useConnectOnboarding = create<ConnectOnboardingState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
}));

/** Help menu entry point. */
export const openConnectOnboarding = () => useConnectOnboarding.getState().setOpen(true);
